import { Grid } from "@mui/material";
import styled from "styled-components";

/**
 * Celda de la cuadricula de Facturacion Global.
 *
 * Va sobre el Grid de MUI v5: mezclarlo con contenedores v5 mientras la celda
 * era v4 descuadraba el spacing --las dos versiones lo resuelven con clases
 * distintas-- y las columnas de Total $ y Total Lt dejaban de alinearse.
 */
export const InvoiceGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
`;
